import React, { Component, Fragment } from "react";
import DayPicker, { DateUtils } from "react-day-picker";
import { connect } from "react-redux";
import { translate, Trans } from "react-i18next";

import { getNextAppointments, updateAppointment } from "actions/appointments";

import Button from "components/Button";
import Loader, { LoaderStyle } from "components/Loader";
import Radiobutton from "components/RadioButton";

import consts from "consts/consts";

import fr from "i18n/fr";
import nl from "i18n/nl";

import style from "./style.css";
import rootStyle from "../../style.css";

const FIRST_DAY_OF_WEEK = 1;

const WEEKDAYS_SHORT = {
  fr: [
    fr.translations.Su,
    fr.translations.Mo,
    fr.translations.Tu,
    fr.translations.We,
    fr.translations.Th,
    fr.translations.Fr,
    fr.translations.Sa,
  ],
  nl: [
    nl.translations.Su,
    nl.translations.Mo,
    nl.translations.Tu,
    nl.translations.We,
    nl.translations.Th,
    nl.translations.Fr,
    nl.translations.Sa,
  ],
};

const WEEKDAYS_LONG = {
  fr: [
    fr.translations.Sunday,
    fr.translations.Monday,
    fr.translations.Tuesday,
    fr.translations.Wednesday,
    fr.translations.Thursday,
    fr.translations.Friday,
    fr.translations.Saturday,
  ],
  nl: [
    nl.translations.Sunday,
    nl.translations.Monday,
    nl.translations.Tuesday,
    nl.translations.Wednesday,
    nl.translations.Thursday,
    nl.translations.Friday,
    nl.translations.Saturday,
  ],
};

const MONTHS = {
  fr: [
    fr.translations.January,
    fr.translations.February,
    fr.translations.March,
    fr.translations.April,
    fr.translations.May,
    fr.translations.June,
    fr.translations.July,
    fr.translations.August,
    fr.translations.September,
    fr.translations.October,
    fr.translations.November,
    fr.translations.December,
  ],
  nl: [
    nl.translations.January,
    nl.translations.February,
    nl.translations.March,
    nl.translations.April,
    nl.translations.May,
    nl.translations.June,
    nl.translations.July,
    nl.translations.August,
    nl.translations.September,
    nl.translations.October,
    nl.translations.November,
    nl.translations.December,
  ],
};

const AVAILABLE_TIMES_HEY = ['AM', 'NOON', 'PM'];

@translate()
@connect((state) => ({
  weCareID: state.session.weCareID,
  nextAppointments: state.appointments.next,
  updateAppointment: state.appointments.update,
}))
export default class FormNextAppointment extends Component {
  stateAppointment = {
    selectedAppointmentDate: undefined,
    selectedAppointmentTime: undefined,
    nextAppointments: undefined,
    availableDates: [],
    startingMonth: undefined,
    endingMonth: undefined,
    modifiers: undefined,
    appointmentTimes: {},
    locale: undefined,
  };

  constructor(data) {
    super(data);
    this.weCareIdValue = "";
  }

  componentDidMount() {
    const { weCareID, appointment } = this.props;
    const appointmentId = appointment.id;
    this.props.dispatch(getNextAppointments(weCareID, appointmentId));
  }

  initState() {
    this.initLocale();
    this.initNextAppointments();
    this.initDates();
  }

  initLocale() {
    const locale = this.props.i18n.language.indexOf("nl") !== -1 ? "nl" : "fr";
    this.setLocale(locale);
  }

  initNextAppointments() {
    const { nextAppointments } = this.props;
    this.setNextAppointments(nextAppointments);
  }

  initDates() {
    const nextAppointments = this.getStateNextAppointments();

    if (nextAppointments.data) {
      const availableDates = [];
      Object.keys(nextAppointments.data).forEach((key) => {
        availableDates.push(new Date(key));
      });

      this.setStartingMonth(availableDates[0]);
      this.setEndingMonth(availableDates[availableDates.length - 1]);
      this.setModifiers({ daysOfWeek: [0, 6] });

      this.setAvailableDates(availableDates);
    }
  }

  getAppName() {
    return process.env.APP_MODE;
  }

  setLocale(locale) {
    this.stateAppointment.locale = locale;
  }

  setNextAppointments(nextAppointments) {
    this.stateAppointment.nextAppointments = nextAppointments;
  }

  setAvailableDates(availableDates) {
    this.stateAppointment.availableDates = availableDates;
  }

  setStartingMonth(startingMonth) {
    this.stateAppointment.startingMonth = startingMonth;
  }

  setEndingMonth(endingMonth) {
    this.stateAppointment.endingMonth = endingMonth;
  }

  setModifiers(modifiers) {
    this.stateAppointment.modifiers = modifiers;
  }

  setAppointmentTimes(times) {
    if (this.getAppName() === consts.mode.heyfix) {
      times = Object.keys(times).filter(key => AVAILABLE_TIMES_HEY.includes(key)).reduce((res, key) => {
        res[key] = times[key];
        return res;
      }, {});
    }
    this.stateAppointment.appointmentTimes = times;
  }

  setSelectedAppointmentDate(day) {
    this.setState({
      selectedAppointmentDate: day
    });
    this.stateAppointment.selectedAppointmentDate = day;
  }

  setSelectedAppointmentTime(time) {
    this.setState({
      selectedAppointmentTime: time
    });
    this.stateAppointment.selectedAppointmentTime = time;
  }

  getLocale() {
    return this.stateAppointment.locale;
  }

  getStateNextAppointments() {
    return this.stateAppointment.nextAppointments;
  }

  getAvailableDates() {
    return this.stateAppointment.availableDates;
  }

  getStartingMonth() {
    return this.stateAppointment.startingMonth;
  }

  getEndingMonth() {
    return this.stateAppointment.endingMonth;
  }

  getModifiers() {
    return this.stateAppointment.modifiers;
  }

  getAppointmentTimes() {
    return this.stateAppointment.appointmentTimes;
  }

  getSelectedAppointmentDate() {
    return this.stateAppointment.selectedAppointmentDate;
  }

  getSelectedAppointmentTime() {
    return this.stateAppointment.selectedAppointmentTime;
  }

  handleDayClick(day, modifiers = {}) {
    if (modifiers.disabled) {
      return;
    }

    let selectDate = modifiers.selected ? undefined : day;
    this.setSelectedAppointmentDate(selectDate);
    this.setSelectedAppointmentTime(undefined);

    if (this.getSelectedAppointmentDate()) {
      Object.keys(this.getStateNextAppointments().data).forEach((date, index) => {
        if (DateUtils.isSameDay(new Date(date), this.getSelectedAppointmentDate())) {
          this.setAppointmentTimes(this.getStateNextAppointments().data[date]);
        }
      });
    }
  }

  handleTimeClick(event) {
    this.setSelectedAppointmentTime(event.target.value);
  }

  formatDate(date) {
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    return `${date.getFullYear()}-${month}-${day}`;
  }

  handleSubmitClick() {
    const { weCareID, appointment } = this.props;
    const { selectedAppointmentTime, selectedAppointmentDate } = this.stateAppointment;
    const appointmentId = appointment.id;
    this.props.dispatch(
      updateAppointment(weCareID, appointmentId, this.formatDate(selectedAppointmentDate), selectedAppointmentTime)
    );
  }

  handleCloseClick() {
    this.props.closeModal();
  }

  orangeRender() {
    return (
      <Fragment>
        {this.getStateNextAppointments().loading && <Loader rootClassname={style.formLoader} style={LoaderStyle.ORANGE} />}
        {!this.getStateNextAppointments().loading &&
          this.getStateNextAppointments().error && (
            <div>
              <p><Trans>An error occurred. Please call 5000 for support.</Trans></p>
              <Button onClick={this.handleCloseClick.bind(this)}><Trans>Close</Trans></Button>
            </div>
          )}
        {!this.getStateNextAppointments().loading &&
          !this.getStateNextAppointments().error &&
          !updateAppointment.data &&
          !this.props.updateAppointment.data && (
            <Fragment>
              <p>
                <Trans>_APPOINTMENT_MODAL_CHANGE_DATE</Trans> -{" "}
                {this.props.appointment && <Trans>{this.props.appointment.type}</Trans>}
              </p>
              <h3><Trans>_APPOINTMENT_MODAL_PICK_A_DATE</Trans></h3>

              <DayPicker
                locale={this.getLocale()}
                canChangeMonth={this.getAvailableDates().length > 0}
                months={MONTHS[this.getLocale()]}
                weekdaysShort={WEEKDAYS_SHORT[this.getLocale()]}
                weekdaysLong={WEEKDAYS_LONG[this.getLocale()]}
                modifiers={this.getModifiers()}
                fixedWeeks
                firstDayOfWeek={FIRST_DAY_OF_WEEK}
                month={this.getStartingMonth()}
                fromMonth={this.getStartingMonth()}
                toMonth={this.getEndingMonth()}
                onDayClick={this.handleDayClick.bind(this)}
                selectedDays={this.getSelectedAppointmentDate()}
                disabledDays={(day) => {
                  let disabled = true;
                  if (this.getAvailableDates()) {
                    this.getAvailableDates().forEach((date) => {
                      if (DateUtils.isSameDay(date, day)) {
                        disabled = false;
                      }
                    });
                  }
                  return disabled;
                }}
              />
              {this.getSelectedAppointmentDate() && (
                <Fragment>
                  <h3><Trans>_APPOINTMENT_MODAL_SELECT_PREFFERED_TIMING</Trans></h3>

                  <div className={style.times}>
                    {this.getAppointmentTimes() &&
                      Object.keys(this.getAppointmentTimes()).map((key, index) => {
                        const appointmentTimes = this.getAppointmentTimes();
                        return (
                          <Radiobutton
                            key={index}
                            rootClassName={style.modalRadioButton}
                            isDisabled={!appointmentTimes[key]}
                            onClick={this.handleTimeClick.bind(this)}
                            label={<Trans>{`${key}_full`}</Trans>}
                            value={key}
                            checked={this.getSelectedAppointmentTime() === key}
                          />
                        );
                      })}
                  </div>
                  <p className={style.calremark}>
                    <Trans defaults="_APPOINTMENT_MODAL_WARNING" values={{ lateCancellationPrice: '59'}} />
                  </p>
                  {this.getSelectedAppointmentTime() && (
                    <Button rootClassName={style.modalSubmit} onClick={this.handleSubmitClick.bind(this)}>
                      {this.props.updateAppointment.loading && (
                        <Loader rootClassname={style.loader} style={LoaderStyle.WHITE} />
                      )}
                      {!this.props.updateAppointment.loading && <Trans>Submit</Trans>}
                    </Button>
                  )}
                  {this.props.updateAppointment.error && (
                    <p className={style.errorMessage}>{this.props.updateAppointment.error.message}</p>
                  )}
                </Fragment>
              )}
            </Fragment>
          )}
        {!this.getStateNextAppointments().loading &&
          !this.props.updateAppointment.loading &&
          this.props.updateAppointment.data &&
          this.props.updateAppointment.data.newAppointmentId && (
            <Fragment>
              <h3>
                <Trans>_APPOINTMENT_SUBMIT_CHANGE_DATE_TITLE</Trans> -{" "}
                {this.props.appointment && <Trans>{this.props.appointment.type}</Trans>}
              </h3>
              <p>
                <Trans>_APPOINTMENT_SUBMIT_MESSAGE</Trans>
              </p>
              <Button onClick={this.handleCloseClick.bind(this)}>
                <Trans>Close</Trans>
              </Button>
            </Fragment>
          )}
      </Fragment>
    );
  }

  heyRender() {
    return (
      <Fragment>
        {this.getStateNextAppointments().loading && <Loader rootClassname={style.formLoader} style={LoaderStyle.ORANGE} />}
        {!this.getStateNextAppointments().loading &&
          this.getStateNextAppointments().error && (
            <div>
              <p><Trans>An error occurred. Please call 5000 for support.</Trans></p>
              <Button onClick={this.handleCloseClick.bind(this)}><Trans>Close</Trans></Button>
            </div>
          )}
        {!this.getStateNextAppointments().loading &&
          !this.getStateNextAppointments().error &&
          !updateAppointment.data &&
          !this.props.updateAppointment.data && (
            <Fragment>
              <div className={rootStyle.fontWeightBold}>
                <p>
                  <Trans>_HEY_APPOINTMENT_MODAL_CHANGE_DATE</Trans> -{" "}
                  {this.props.appointment && <Trans>{this.props.appointment.type}</Trans>}
                </p>
                <h3><Trans>_HEY_APPOINTMENT_MODAL_PICK_A_DATE</Trans></h3>

                <DayPicker
                  locale={this.getLocale()}
                  canChangeMonth={this.getAvailableDates().length > 0}
                  months={MONTHS[this.getLocale()]}
                  weekdaysShort={WEEKDAYS_SHORT[this.getLocale()]}
                  weekdaysLong={WEEKDAYS_LONG[this.getLocale()]}
                  modifiers={this.getModifiers()}
                  fixedWeeks
                  firstDayOfWeek={FIRST_DAY_OF_WEEK}
                  month={this.getStartingMonth()}
                  fromMonth={this.getStartingMonth()}
                  toMonth={this.getEndingMonth()}
                  onDayClick={this.handleDayClick.bind(this)}
                  selectedDays={this.getSelectedAppointmentDate()}
                  disabledDays={(day) => {
                    let disabled = true;
                    if (this.getAvailableDates()) {
                      this.getAvailableDates().forEach((date) => {
                        if (DateUtils.isSameDay(date, day)) {
                          disabled = false;
                        }
                      });
                    }
                    return disabled;
                  }}
                />
                {this.getSelectedAppointmentDate() && (
                  <Fragment>
                    <h3><Trans>_HEY_APPOINTMENT_MODAL_SELECT_PREFFERED_TIMING</Trans></h3>

                    <div className={style.times}>
                      {this.getAppointmentTimes() &&
                        Object.keys(this.getAppointmentTimes()).map((key, index) => {
                          const appointmentTimes = this.getAppointmentTimes();
                          return (
                            <Radiobutton
                              key={index}
                              rootClassName={style.modalRadioButton}
                              isDisabled={!appointmentTimes[key]}
                              onClick={this.handleTimeClick.bind(this)}
                              label={<Trans>{`${key}_full`}</Trans>}
                              value={key}
                              checked={this.getSelectedAppointmentTime() === key}
                            />
                          );
                        })}
                    </div>

                    <p className={rootStyle.textColorRed}>
                      <Trans defaults="_HEY_APPOINTMENT_MODAL_WARNING" values={{ lateCancellationPrice: '59'}} />
                    </p>
                    {this.getSelectedAppointmentTime() && (
                      <Button rootClassName={style.modalSubmit} onClick={this.handleSubmitClick.bind(this)}>
                        {this.props.updateAppointment.loading && (
                          <Loader rootClassname={style.loader} style={LoaderStyle.WHITE} />
                        )}
                        {!this.props.updateAppointment.loading && <Trans>_HEY_APPOINTMENT_MODAL_SUBMIT_BUTTON</Trans>}
                      </Button>
                    )}
                    {this.props.updateAppointment.error && (
                      <p className={style.errorMessage}>{this.props.updateAppointment.error.message}</p>
                    )}
                  </Fragment>
                )}
              </div>
            </Fragment>
          )}
        {!this.getStateNextAppointments().loading &&
          !this.props.updateAppointment.loading &&
          this.props.updateAppointment.data &&
          this.props.updateAppointment.data.newAppointmentId && (
            <Fragment>
              <div id={"confirmationModal"} className={rootStyle.fontWeightBold}>
                <h3>
                  <Trans>_HEY_APPOINTMENT_SUBMIT_CHANGE_DATE_TITLE</Trans> -{" "}
                  {this.props.appointment && <Trans>{this.props.appointment.type}</Trans>}
                </h3>

                <p><Trans>_HEY_APPOINTMENT_SUBMIT_MESSAGE</Trans></p>

                <Button onClick={this.handleCloseClick.bind(this)}>
                  <Trans>_HEY_APPOINTMENT_SUBMIT_BUTTON_CLOSE</Trans>
                </Button>
                {this.errorGetAppointment && (
                  <p className={style.errorMessage}>{this.errorGetAppointment.message}</p>
                )}
              </div>
            </Fragment>
          )}
      </Fragment>
    );
  }

  renderSwitch() {
    switch (process.env.APP_MODE) {
      case consts.mode.heyfix: return this.heyRender();
      default: return this.orangeRender();
    }
  }

  render() {
    this.initState();
    return this.renderSwitch();
  }
}



// WEBPACK FOOTER //
// ./src/containers/FormNextAppointment/index.js